import { MethodType, GenerateUrlApiType, ResponseType, ParamsFetchType} from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';


import { openapi_website_cms_getFilesImages, decodeResponse200, Response200Type, ParamsType } from 'src/api_openapi/generated/openapi_website_cms_getFilesImages';


export type FilesListCMSModelType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Array<FilesListCMSModelType> => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};
export type FilesListCMSTypeSubmitType = ParamsType['body']

export const getCMSFilesList = {
    browser: {
        params: (params: FilesListCMSTypeSubmitType): ParamsFetchType<FilesListCMSTypeSubmitType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/get-files-cms-list',
                body: params
            };
        },
        decode: decode,
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/get-files-cms-list',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<FilesListCMSTypeSubmitType>): Promise<GenerateUrlApiType> => {

        const response = await openapi_website_cms_getFilesImages(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    },
};
